import { gsap } from 'gsap'
import { breakpoint } from '../utilities/screen_setup'


if (breakpoint('full') > breakpoint('md')) {

  gsap.to(".text-on-image-bg", {
    scrollTrigger: {
      trigger: "#quotes-scroll",
      scrub: true,
      start: '-=15% center',
      end: "top center",
      //markers: false
    },
    width: '100%',
    transformOrigin: "center center",
    ease: 'power2',
  })
}

if (breakpoint('full') > breakpoint('md') && document.getElementById("animate-fade")) {
  var targets = document.getElementById("animate-fade").children;
  var i = 0
  for (let target of Array.from(targets)) {
    const tl = gsap.timeline({
      defaults: {duration: 1},
      force3D: false,
      scrollTrigger: {
        trigger: '.block-text-on-image',
        scrub: true,
        start: "top+=20% " + (100 - i * 10) + '%',
        //markers: true,

      }
    })
      .from(target, {opacity: 0, duration: 1}, 0)
      .to(target, {opacity: 0, duration: 1}, 1)
    i++
  }
}
